import lottie from "lottie-web";

const _E3_LOADER_ANIMATION = "_E3_LOADER_ANIMATION";

function preparePreloader() {
	const logo = document.getElementById("loaderLogo");
	if (!logo) {
		console.warn("loaderLogo missing");
		return;
	}

	const animation = lottie.loadAnimation({
		container: logo,
		renderer: "svg",
		loop: false,
		autoplay: false,
		path: "./media/common/loader/logo_preloader.json",
	});

	window[_E3_LOADER_ANIMATION] = {
		remove: () => {
			animation.destroy();
			logo.remove();
		},
		hide: () => {
			animation.pause();
			logo.classList.add("hidden-logo");
		},
		showStatic: () => {
			if (logo.children.length) {
				// Already one logo is added, ignore the second one.
				return;
			}
			animation.goToAndStop(200, true);
			logo.classList.remove("hidden-logo");
			let logoAttributes = {width: "50%", height: "50%", marginTop: window.innerHeight * 0.5, marginLeft: window.innerWidth * 0.25};
			const handlers = {
				'vip': () => { logoAttributes.height = "25%"; },
				'empire': () => {
					logoAttributes.height = "35%";
					logoAttributes.marginTop = 2004;
				},
				'prince': () => {
					logoAttributes.height = "35%";
					logoAttributes.marginTop = window.innerHeight * 0.375;
				},
				'es_premium': () => {
					logoAttributes.width = "28%";
					logoAttributes.height = "25%";
					logoAttributes.marginLeft = 340;
					logoAttributes.marginTop = 1450;
				},
				'esj_esn': () => { logoAttributes.marginTop = window.innerHeight * 0.3; },
				'es3': () => {
					logoAttributes.height = "25%";
					logoAttributes.marginTop = 1200;
				},
			};
			Object.keys(handlers).some((key) => {
				if (!location.href.includes(key)) {
					return false;
				}

				if (handlers[key]) {
					handlers[key]();
				}
				return true;
			});
			logo.setAttributeNS(null, "style", `width: ${logoAttributes.width}; height: ${logoAttributes.height}; margin-top: ${logoAttributes.marginTop}px; margin-left: ${logoAttributes.marginLeft}px;`);
		},
		show: () => {
			// animation.goToAndStop(45, true); // First visible frame should have full BF logo displayed.
			logo.classList.remove("hidden-logo");
			logo.setAttributeNS(null, "style", "height: 90%");
			animation.play();
		},
		resize: (rect) => {
			logo.setAttributeNS(null, "style", `width:${rect.width}px;`); // margin-top:${rect.y}px
		},
		pause: () => {
			// animation.goToAndStop(45, true);
			logo.classList.remove("hidden-logo");
		},
	};

	// TODO: how can we make check if we are running machine game?
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const gameName = urlParams.get('gameName').toLowerCase();


	if (gameName.includes("_machine") || gameName.includes("_es_premium")) {
		window[_E3_LOADER_ANIMATION].showStatic();
	}
}

preparePreloader();
